export enum GLOBAL_STATE_CATEGORIES {
  ACCOUNT = 'account',
  ACTIVATION = 'activation',
  PORTING = 'porting',
  PLAN = 'plan',
  SOCIAL = 'social_tariff',
  PLAN_CHANGE = 'plan_change',
  MANUAL_RENEWAL = 'manual_renewal',
  FAMILY_PLAN = 'family_plan',
}

export enum GroupV1PortInStatuses {
  PORT_REQUESTED = 'port_requested',
  PORT_SUCCESS = 'port_success',
  PORT_FAILURE = 'port_failure',
  PORT_CANCELLED = 'port_cancelled', // not for ULFP
  PORT_SKIPPED = 'port_skipped', // is absent on BE
  PORT_EXPIRED = 'port_expired', // is absent on BE
  MAYBE_PORT_SKIPPED = 'maybe_port_skipped', // is absent on BE(confirmed by Oleksii Bochurkin)
  MAYBE_PORT_AFTER_ORDER = 'maybe_port_after_order', // rare but possible
}

export enum GLOBAL_STATE_TYPES {
  ACTIVE = 'active',
  AWAITING_NEW_SIM = 'awaiting_new_sim',
  AWAITING_NUMBER = 'awaiting_number',
  AWAITING_ORDER = 'awaiting_order',
  AWAITING_UNDELIVERED_SIM = 'awaiting_undelivered_sim',
  CAN_RENEW = 'can_renew',
  EXPIRED = 'expired',
  NEW_SIM_ACTIVATION_REQUESTED = 'new_sim_activation_requested',
  // eslint-disable-next-line @typescript-eslint/no-duplicate-enum-values
  NEW_SIM_REQUESTED = 'awaiting_new_sim',
  PAUSED = 'paused',
  PAYMENT_REQUIRED = 'payment-required',
  PENDING = 'pending',
  REQUESTED = 'requested',
  SUCCESS = 'success',
  SUSPENDED = 'suspended',
  TERMINATED = 'terminated',
  FAILURE = 'failure',
  ACTIVATION_REQUESTED = 'activation_requested',
  AWAITING_ACTIVATION = 'activation_pending',
  ACTIVATION_FAILED = 'activation_failed',
}
